import { render, staticRenderFns } from "./DetailInvoiceVAT.vue?vue&type=template&id=319e84c2"
import script from "./DetailInvoiceVAT.vue?vue&type=script&lang=js"
export * from "./DetailInvoiceVAT.vue?vue&type=script&lang=js"
import style0 from "./DetailInvoiceVAT.vue?vue&type=style&index=0&id=319e84c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports